import { VgApiResult, vgApiRequest } from "./vg-api.service";

/**
 * A provider's Stripe account, through which Funely pays it its share of what families pay.
 * Mirrors ProviderPaymentAccount in api/Funely/BundlePayment.cs.
 */
export type PaymentAccount = {
  /** none, onboarding, ready or restricted. */
  state: string;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
  detailsSubmitted: boolean;
  /** A one-time link to Stripe's forms, only straight after starting onboarding. */
  onboardingUrl: string;
};

// vgApiRequest already turns a refused func_status into an error; the payload is in data.
type Envelope<T> = { data?: T | null };

const unwrap = <T,>(result: VgApiResult<Envelope<T>>): VgApiResult<T> =>
  result.error ? { data: null, error: result.error } : { data: (result.data?.data as T) ?? null, error: null };

export const readPaymentAccount = async (accessToken: string, orgId: number): Promise<VgApiResult<PaymentAccount>> =>
  unwrap(await vgApiRequest<Envelope<PaymentAccount>>(accessToken, "Read_Payment_Account", { orgId }));

/** Creates the Stripe account the first time; returns a fresh link to Stripe's forms. */
export const startPaymentOnboarding = async (accessToken: string, orgId: number): Promise<VgApiResult<PaymentAccount>> =>
  unwrap(await vgApiRequest<Envelope<PaymentAccount>>(accessToken, "Start_Payment_Onboarding", { orgId }));
